module.exports = __webpack_public_path__ + "static/nor-wes_univ-0fb39c3843a6b77a87c3e7b8890a5e37.png";